export enum NotificationTypesEnums {
  newLike = 'App\\Notifications\\Like\\NewLike',
  newFollower = 'App\\Notifications\\Follow\\NewFollow',
  newComment = 'App\\Notifications\\Comment\\NewComment'
}

export enum NotificationSubTypesEnums {
  commentSubType = 'App\\Models\\Comment\\Comment',
  reviewSubType = 'App\\Models\\Review\\Review',
  postSubType = 'App\\Models\\Post\\Post'
}
